import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import { AuthContext } from '../../context/AuthContext';

const WithdrawDash = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useContext(AuthContext);

  useEffect(() => {
    // Wait until auth state is resolved
    if (!authLoading && !user) {
      navigate('/login', { replace: true });
      return;
    }
    // Without a purchased plan this page has nothing to show - go to Wallets
    const hasActivePlan = Boolean(user?.planId) && user?.status === 'active';
    if (!authLoading && user && !hasActivePlan) {
      navigate('/wallets', { replace: true });
    }
  }, [authLoading, user, navigate]);

  if (authLoading) {
    return (
      <DashboardLayout>
        <div className="loading-spinner"></div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <h1>Withdraw</h1>
    </DashboardLayout>
  );
};

export default WithdrawDash;
